export const fnBuildFormikInitialNameValues = (sFullName) => {
  const [sFirstName, sLastName = ''] = sFullName.split(' ');
  return {
    firstName: sFirstName.charAt(0).toUpperCase() + sFirstName.slice(1),
    lastName: sLastName.charAt(0).toUpperCase() + sLastName.slice(1),
  };
};

export default {};
